<template>
  <dashboard-skeleton v-if="loading"></dashboard-skeleton>
  <div v-else>
    <ContentHeader :title="displayName" />
    <section class="content">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-6 pl-xl-2 pr-xl-2">
            <div class="info-box">
              <router-link
                :to="{ name: 'IntroducingBroker' }"
                class="info-box-icon bg-info elevation-1" style="width:90px;"
              >
                <i class="fa fa-user-secret"></i>
              </router-link>

              <div class="info-box-content">
                <h4 class="info-box-text">Current Personnel</h4>
                <h2 class="info-box-number" v-if="dataReady">
                  {{ ibs }}
                </h2>
                <h2 class="info-box-number" v-else> 0 </h2>
              </div>
              <!-- /.info-box-content -->
            </div>
          </div>
          <!-- /.col -->
          <div class="col-md-6 pl-xl-2 pr-xl-2">
            <div class="info-box mb-3">
              <router-link
                :to="{ name: 'IbRequest' }"
                class="info-box-icon bg-danger elevation-1" style="width:90px;"
                ><i class="fas fa-hand-paper"></i>
              </router-link>

              <div class="info-box-content">
                <h4 class="info-box-text">Career Request</h4>
                <h2 class="info-box-number" v-if="dataReady">{{
                  Ib_request
                }}</h2>
                <h2 class="info-box-number" v-else>0</h2>
              </div>
              <!-- /.info-box-content -->
            </div>
            <!-- /.info-box -->
          </div>
          <!-- /.col -->

          <div class="col-md-6 pl-xl-2 pr-xl-2">
            <div class="info-box mb-3">
              <router-link
                :to="{
                  name: 'IntroducingBroker',
                  query: { is_active: true },
                }"
                class="info-box-icon bg-success elevation-1" style="width:90px;"
                ><i class="fas fa-users"></i>
              </router-link>

              <div class="info-box-content">
                <h4 class="info-box-text">Active Personnel</h4>
                <h2 class="info-box-number" v-if="dataReady">{{
                  ib_active
                }}</h2>
                <h2 class="info-box-number" v-else>0</h2>
              </div>
              <!-- /.info-box-content -->
            </div>
            <!-- /.info-box -->
          </div>
          <!-- /.col -->
          <div class="col-md-6 pl-xl-2 pr-xl-2">
            <div class="info-box mb-3">
              <router-link
                :to="{
                  name: 'IbUpLevel',
                  query: { is_active: false },
                }"
                class="info-box-icon bg-warning elevation-1" style="width:90px;"
                ><i class="fas fa-user-check"></i>
              </router-link>

              <div class="info-box-content">
                <h4 class="info-box-text">UP Level Request</h4>
                <h2 class="info-box-number" v-if="dataReady">{{
                  Ib_up_level
                }}</h2>
                <h2 class="info-box-number" v-else>0</h2>
              </div>
              <!-- /.info-box-content -->
            </div>
            <!-- /.info-box -->
          </div>
          <!-- /.col -->
        </div>
        <div class="row">
          <section class="col-lg-12 connectedSortable">
            <div class="card">
              <!-- <div class="card-header">
                <h3 class="card-title">
                  Disbursement
                </h3>
              </div> -->
              <div class="card-body">
                <h4>
                  Disbursement
                </h4><br>
                <div class="tab-content p-0 pt-lg-2">
                  <div class="row">
                    <div class="pl-lg-5 col-lg-3 col-xl-2">
                      <h1 class="icon-wallet">
                        <i class="fas fa-wallet"></i>
                      </h1>
                    </div>
                    <div class="pl-lg-4 pt-lg-2 col-lg-9 col-xl-10">
                      <h2 class="header-current">Current Disbursement</h2>
                      <div v-if="alldatadisbursement.length > 0">
                        <h2 class="current" v-for="currency_specific in alldatadisbursement" :key="currency_specific.currency">
                          {{currency_specific.currency == 'USD'?'$':'Rp.'}} 
                          <span v-if="currency_specific.currency == 'IDR'">{{new Intl.NumberFormat('id-ID').format(Number(currency_specific.total).toFixed())}}</span>
                          <span v-else>{{currency_specific.tota}}</span>
                        </h2>
                        <!-- <h1 class="current" v-if="alldatadisbursement[0].currency == 'USD'">$ {{alldatadisbursement[0].total}}</h1>
                        <h1 class="current" v-else-if="alldatadisbursement[0].currency == 'IDR'">Rp. {{alldatadisbursement[0].total}}</h1> -->
                      </div>
                      <div v-else-if="alldatadisbursement.length <= 0">
                        <h1 class="current">0</h1>
                      </div>
                      <router-link to="/disbursement" class="btn btn-outline-danger">
                        View Detail
                      </router-link>
                    </div>
                  </div>
                  <!-- <line-chart :data="chartData"></line-chart> -->
                </div>
              </div>
            </div>
          </section>
          <section class="col-lg-5 connectedSortable"></section>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
// @ is an alias to /src
import ContentHeader from "@/components/molecules/ContentHeader.vue";
import DashboardSkeleton from "@/components/loading-screen/DashboardSkeleton.vue";
import apiIB from "../services/ApiServicesIB";
import apiClient from '../services/ApiServices';

export default {
  name: "Dashboard",
  data() {
    return {
      loading: true,
      disbursement:[],
      alldatadisbursement:[],
      ibs: 0,
      Ib_request:0,
      Ib_up_level:0,
      ib_active: "",
      ib_non_active: "",
      current_user: this.$store.getters.user,
      corporatepartner_id: this.$store.getters.user.id,
      dataReady: false,
      chartData: {
        "2017-05-13": 2,
        "2017-05-14": 5,
        "2017-05-15": 3,
      },
    };
  },
  created() {
    document.title = "Dashboard - Manajer Cabang";
  },

  computed: {
    user() {
      return this.$store.state.user;
    },
    displayName() {
      var ndate = new Date();
      var hours = ndate.getHours();
      var message =
        hours < 12
          ? "Good Morning, "
          : hours < 18
          ? "Good Afternoon, "
          : "Good Evening, ";
      return (
        message +
        this.user.username.charAt(0).toUpperCase() +
        this.user.username.slice(1)
      );
    },
  },

  components: {
    ContentHeader,
    DashboardSkeleton,
  },

  async mounted() {
    
    try {
      let ibCount = await apiIB.get(`?corporate_id=${this.$user_id}&limit=1`);
      let IB_REQUEST = await apiIB.get(
        `?corporate_id=${this.$user_id}&admission_status=PENDING&limit=1`
      );
      let activeIb = await apiIB.get(
        `?corporate_id=${this.$user_id}&is_active=${true}&limit=1`
      );
      let IB_UPLEVEL = await apiIB .get(
        `advancement/?corporate_partner_id=${this.$user_id}&limit=1`
      );
      let disbursementtotal = await apiClient.get(`${this.$user_id}/disbursement/total/`);
      
      
      this.alldatadisbursement = disbursementtotal.data.data
      this.ibs = ibCount.data.meta.count;
      this.Ib_request = IB_REQUEST.data.meta.count;
      this.ib_active = activeIb.data.meta.count;
      this.Ib_up_level = IB_UPLEVEL.data.meta.count;
      this.dataReady = true;
    } catch (error) {
      this.$swal(
        "Oooopss....",
        error.data.data.message,
        "error"
      );
    } finally {
      this.loading = false
      
    }
  },
  
};
</script>
<style scoped>
  .icon-wallet{
    font-size: 4rem;
    color: rgb(86, 85, 85);
  }
  .header-current{
    font-size: 1rem;
    font-weight: 500;
  }
  .current{
    font-size: 1.5rem;
    font-weight: 700;
  }
@media (min-width: 767px) {
  .icon-wallet{
    font-size: 9rem;
  }
  .header-current{
    font-size: 2rem;
    font-weight: 500;
  }
  .current{
    font-size: 2.5rem;
    font-weight: 700;
  }
}

</style>
